import React, { useEffect, useState } from "react";
import bgImageDesktop from "./assets/images/background-pattern-desktop.svg";
import bgImageMoible from "./assets/images/background-pattern-mobile.svg";

import starIcon from "./assets/images/icon-star.svg";
import plusIcon from "./assets/images/icon-plus.svg";
import minusIcon from "./assets/images/icon-minus.svg";

const App = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const faqs = [
        {
            question: "What is Frontend Mentor, and how will it help me?",
            answer: "Frontend Mentor offers realistic coding challenges to help developers improve their frontend coding skills with projects in HTML, CSS, and JavaScript. It's suitable for all levels and ideal for portfolio building.",
        },
        {
            question: "How do I get started with Frontend Mentor?",
            answer: "To get started, sign up for an account, choose a challenge, and start coding. You can submit your solution for feedback and see how others have approached the same problem.",
        },
        {
            question: "Can I use libraries and frameworks?",
            answer: "Yes! You're encouraged to use whatever tools help you complete the project. Whether it's vanilla CSS or Tailwind, React or Vue, you're free to choose.",
        },
        {
            question: "How do I improve my solutions?",
            answer: "After submitting, you can view feedback from others, see alternative solutions, and refactor your code to improve readability and efficiency.",
        },
    ];

    return (
        <div className="w-full bg-lightPink">
            <img
                src={width > 900 ? bgImageDesktop : bgImageMoible}
                alt="background"
                className="w-full object-cover object-center absolute top-0 left-0 z-0"
            />

            <section className="relative z-10 flex flex-col items-center justify-center min-h-screen">
                <div className="lg:w-[600px] max-w-[90%] my-10 lg:my-0 bg-white p-10 rounded-2xl shadow-lg">
                    <div className="flex items-center mb-4">
                        <img
                            src={starIcon}
                            alt="star"
                            className="mr-6 size-[40px]"
                        />
                        <h1 className="display">FAQs</h1>
                    </div>
                    {faqs.map((faq, index) => (
                        <Accordion
                            key={index}
                            question={faq.question}
                            answer={faq.answer}
                            isLast={index === faqs.length - 1}
                        />
                    ))}
                </div>
            </section>
        </div>
    );
};

const Accordion = ({ question, answer, isLast }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`py-4 ${!isLast ? "border-b border-lightPink" : ""}`}>
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <p className="title text-darkPurple">{question}</p>
                <img
                    src={isOpen ? minusIcon : plusIcon}
                    alt="toggleIcon"
                    className="w-6 h-6"
                />
            </div>
            {isOpen && <p className="body text-palePink mt-4">{answer}</p>}
        </div>
    );
};

export default App;
